import { LoginService } from 'src/app/login/login.service';
import { Governamental } from './../governamental';
import { PessoaService } from './../../pessoa.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { Federacao } from '../../federacao/federacao';
import { SYSCONF_SIGLA } from 'src/app.api';
@Component({
	selector: 'app-governamental-edit',
  	templateUrl: './governamentalEdit.component.html',
  	styleUrls: ['./governamentalEdit.component.scss']
})
export class GovernamentalEditComponent implements OnInit{
	@ViewChild('Swal') public swal:SwalComponent; 
	federacoes: Federacao[];
	public message:string = '';
	editForm: FormGroup;
	governamental: Governamental;
	governamental_id:number;
	thumb:string = '';
	pessoa_id:number;
	enderecos:object = new Array();
	telefones:object = new Array();
	contasBancarias:object = new Array();
	sigla = SYSCONF_SIGLA;
	anexos: any;
	acesso = new Array();
	constructor(public loginService:LoginService, private pessoaService: PessoaService , private activatedRoute: ActivatedRoute ,private formBuilder: FormBuilder){
		this.editForm = this.formBuilder.group({
			id: this.formBuilder.control(0,[Validators.required]),
			dt_cadastro: this.formBuilder.control(''),
			dt_atualizacao: this.formBuilder.control(''),
			cnpj: this.formBuilder.control('',[Validators.required]),
			razao_social: this.formBuilder.control('',[Validators.required]),
			nome_completo: this.formBuilder.control('',[Validators.required]),
			email: this.formBuilder.control('',[Validators.required, Validators.email]),
			status: this.formBuilder.control('',[Validators.required]),
			sigla: this.formBuilder.control('',[Validators.required]),
			tipo: this.formBuilder.control('',[Validators.required]),
			website: this.formBuilder.control(''),
			observacao: this.formBuilder.control('')
		});	
		this.governamental_id = this.activatedRoute.snapshot.params['id'];
		this.pessoaService.getPessoaById('pessoa/governamental',this.governamental_id).subscribe(
			(governamental) => {
			this.governamental = governamental.dados;
			this.pessoa_id = this.governamental.pessoa_id;
			this.acesso = this.governamental.acesso;
			if(this.governamental.foto){
				this.thumb = this.governamental.foto.thumb;
			}
			this.pessoaService.getPessoaById('pessoa',this.pessoa_id).subscribe(
				(success) =>{
					this.enderecos = success.dados.endereco;
					this.telefones = success.dados.telefone;
					this.contasBancarias = success.dados.conta_bancaria;
					this.anexos = success.dados.anexo;
				},
				(error) => {
					this.message = error.error.message;
				})
			
			this.editForm.patchValue({
				id: this.governamental.id,
				dt_cadastro: this.governamental.dt_cadastro_br,
				dt_atualizacao: this.governamental.dt_atualizacao_br,
				cnpj: this.governamental.cnpj,
				razao_social: this.governamental.razao_social,
				nome_completo: this.governamental.nome_completo,
				email: this.governamental.email,
				status: this.governamental.status,
				sigla: this.governamental.sigla,
				tipo: this.governamental.tipo,
				website: this.governamental.website,
				observacao: this.governamental.observacao
			});
			
		},
		(error) => {
			this.message = error.error.message;
		})
	}
	ngOnInit(){
		let t = JSON.parse(localStorage.getItem('CONFLogin'));
		if(!t.permissao.pessoa_governamental.includes("EDITAR"))
			this.message = 'Você não possui permissão para executar esta ação'
	}	
}